<template>
    <b-container class="faq-detail" fluid>
        <b-row>
            <b-col class="content-col" cols="8">
                <b-row class="list-item">
                    <b-col class="module" v-html="faq.content">

                    </b-col>
                </b-row>
                <b-row style="margin-top: 100px">
                    <b-col>
                        <div class="title">
                            {{faq.related.title}}
                        </div>
                        <div class="item" v-for="(item, itemIndex) in faq.related.items" :key="itemIndex" @click="redirect(item.slug)">
                            <a :href="'/faq/' + item.slug" onclick="return false">
                                - <span>{{item.text}}</span>
                            </a>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="contact-col" cols="4">
                <b-row class="list-item">
                    <b-col v-for="(item, itemIndex) in faq.items" :key="itemIndex" class="col">
                        <b-card :title="item.name">
                            <b-card-text v-for="(text, textIndex) in item.desc" :key="textIndex">
                                <div v-html="text"></div>
                            </b-card-text>

                            <div class="images">
                                <div v-for="(img, imgIndex) in item.images" :key="imgIndex" class="imag-item">
                                    <div>
                                        <img :src="img.imgSrc">
                                    </div>
                                    <p v-html="img.title"></p>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'faqDetail',
        components: {

        },
        computed: {
            ...mapState('faqDetail', {
                faq: ({faq}) => {
                    return {
                        items: faq.contact_infos.map(contact=>{
                            return {
                                name: contact.title,
                                desc: [contact.description],
                                images: contact.qr_codes && contact.qr_codes.map(img => {
                                    return {
                                        imgSrc: img.qr_code_pic_url,
                                        title: img.qr_text,
                                    }
                                })
                            }
                        }),
                        content: faq.content,
                        related: {
                            title: faq.related_faq.title,
                            items: faq.related_faq.items && faq.related_faq.items.map(item => {
                                return {
                                    text: item.title,
                                    slug: item.slug,
                                }
                            })
                        }
                    }
                },

            })
        },
        methods: {
            ...mapActions('faqDetail', ['getPageInfo']),
            redirect(slug) {
                this.$router.push({
                    path: '/faq/' + slug
                })

                document.scrollingElement.scrollTop = 0

                location.reload()
            }
        },
        created() {
            this.getPageInfo(this.$route.params.id)
        }
    }
</script>

<style lang="less">
    @import "../assets/style/var";

    h1 {
        margin: 0 0 20px 0;
        font-size: 30px;
        line-height: 45px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
    }

    h3 {
        margin: 52px 0 20px 0;
        font-size: 18px;
        line-height: 30px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
    }

    .cn {
        h5 {
            font-size: 14px;
            line-height: 28px;
            color: #333;
            font-weight: bold;
        }
    }

    .en {
        h5 {
            font-size: 13px;
            line-height: 28px;
            color: #333;
            font-weight: bold;
        }
    }

    p {
        font-size: 14px;
        line-height: 28px;
        margin-bottom: 20px;
    }

    .en {
        h1 {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }

        h3 {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }
        .faq-detail {
            .content-col {
                .title {
                    font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
                }
            }

            .card {
                .card-body {
                    .card-title {
                        font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
                    }
                }
            }
        }
    }

    .faq-detail {
        margin-top: 204px;
        padding: 0 150px;

        .module {
            text-align: left;
        }

        .content-col {
            padding-right: 80px;
            .title {
                margin-bottom: 20px;
                font-size: 18px;
                line-height: 30px;
                font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
            }

            .item {
                font-size: 14px;
                line-height: 28px;
                cursor: pointer;

                span {
                    text-decoration: underline;
                }

                &:nth-child(n+2) {
                    margin-top: 8px;
                }
            }
        }

        .contact-col {
            padding-left: 80px;
            border-left: .5px solid #BDBDBD;
        }

        .list-item {
            .col {
                &:nth-child(n+3) {
                    margin-top: 84px;
                }
            }
        }

        /deep/ .card {
            border: none;

            .card-body {
                padding: 0;
                text-align: left;

                .card-title {
                    margin-bottom: 20px;
                    font-size: 20px;
                    line-height: 28px;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
                }

                .card-text {
                    font-size: 14px;
                    line-height: 28px;
                    margin-bottom: 0 !important;

                    div {
                        p {
                            a {
                                text-decoration:none;
                                color: #000;
                            }
                        }
                    }
                }
            }
        }

        .contact {
            .title {
                margin: 121px auto 50px auto;
                text-align: center;
                font-size: 18px;
                line-height: 27px;
            }

            .btn-container {
                text-align: center;
                .btn {
                    width: 400px;
                    font-size: 18px;
                    line-height: 27px;
                }
            }
        }

        .images {
            display: flex;
            margin-top: 30px;
            //justify-content: space-between;

            .imag-item {
                &:nth-child(n+2) {
                    margin-left: 60px;
                }

                img {
                    width: 120px;
                    margin-bottom: 15px;
                }

                p {
                    font-size: 14px;
                    line-height: 28px;
                    margin: 0;
                    text-align: center;
                }
            }
        }
    }
</style>
